import React, { useEffect, useState } from 'react';

const ScrollProgress = () => {
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY; // Текущая прокрутка
            const docHeight = document.documentElement.scrollHeight - window.innerHeight; // Общая высота страницы
            const scrollPercent = (scrollTop / docHeight) * 100; // Процент прокрутки

            setScrollProgress(scrollPercent);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className='scroll-progress'
            style={{
                width: `${scrollProgress}%`,
            }}
        />
    );
};

export default ScrollProgress;
